import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'

import { BirthdayCatalog } from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const fetchBirthdayCatalog = async (): Promise<BirthdayCatalog> => {
  const response = await axios.get<BirthdayCatalog>(
    `${getEndpoint()}/birthday/catalog`
  )
  return response.data
}

export const useBirthdayCatalog = () =>
  useQuery<BirthdayCatalog, AxiosError>(
    ['birthday', 'catalog'],
    fetchBirthdayCatalog
  )
